// extracted by mini-css-extract-plugin
export var errorIcon = "_ma-1";
export var nameLogo = "_ma-0";